/** Format a seconds count as a short human label, e.g. "1h 24m" or "42m". */
export const formatDuration = (totalSeconds) => {
  if (!totalSeconds || totalSeconds <= 0) return null;
  const totalMinutes = Math.max(1, Math.round(totalSeconds / 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};

/** Progress-card subtitle: "42m left", "Done", or null if the course has no timed content. */
export const formatTimeRemaining = (remainingSeconds, completedCount, lessonCount) => {
  if (lessonCount > 0 && completedCount >= lessonCount) return 'Done';
  const label = formatDuration(remainingSeconds);
  return label ? `${label} left` : null;
};
